<h2 class="text-tertiary d-flex justify-content-between uppercase">
  <span mat-dialog-title>{{
    multilingualService.langMap?.TITLE_CLAIM_DETAILS_SCREEN
  }}</span>
  <button
    mat-dialog-close
    class="close"
    mat-icon-button
    [attr.aria-label]="multilingualService?.langMap?.LABEL_CLOSE_DIALOG"
  >
    <mat-icon class="icon-cross"></mat-icon>
  </button>
</h2>

<ng-container *ngIf="claimDetails && !isLoading">
  <mat-dialog-content class="mat-typography">
    <div class="view-detail">
      <div class="list-view d-flex">
        <div class="custom-block-width">
          <h5 class="text-tertiary title-10 text-w-500">
            {{multilingualService.langMap?.LABEL_CLAIM_DETAILS_CLAIM_INFORMATION}}</h5>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIMS_CLAIM_ID}}</label>
              <p>{{ claim.claimId }}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_PROCESSED_DATE}}</label>
              <p>{{claimDetails?.claim?.processedDate  | date: 'MM-dd-yyyy'}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_MAIL_ORDER_DETAILS_RX_NUMBER}}</label>
              <p>{{claimDetails?.claim?.rxNumber}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_LIST_CLAIMS_RX_FILL_DATE}} </label>
              <p>{{claimDetails?.claim?.fillDate | date: 'MM-dd-yyyy'}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIMS_RX_NUMBER}}</label>
              <p>{{claimDetails?.claim?.fillNumber}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_WRITTEN_DATE}}</label>
              <p>{{claimDetails?.claim?.dateWritten | date: 'MM-dd-yyyy'}}</p>
            </div>
          </div>

          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_DRUG_PRICING_QUANTITY}}</label>
              <p>{{claimDetails?.claim?.quantity}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_COMPOUND}} (Code)</label>
              <p>{{claimDetails?.claim?.compoundCode}}</p>
            </div>
          </div>
        </div>
        <div class="custom-block-width mr-4">

          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_DAYS_SUPPLY}}</label>
              <p>{{claimDetails?.claim?.daySupply}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_DAW}}</label>
              <p>{{claimDetails?.claim?.dispenseAsWritten}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_PRESCRIBER_NAME}}</label>
              <p>{{claimDetails?.claim?.prescriberFirstName}} {{claimDetails?.claim?.prescriberLastName}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_PHARMACY_NAME}}</label>
              <p>{{claimDetails?.claim?.pharmacyName}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_NPI}}</label>
              <p>{{claimDetails?.claim?.pharmacyNpi}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_PRESCRIBER_NPI}}</label>
              <p>{{claimDetails?.claim?.prescriberNpi}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_PHARMA_ADDRESS}}</label>
              <p>{{claimDetails?.claim?.pharmacyAddress?.addressLine1}},
                {{claimDetails?.claim?.pharmacyAddress?.addressLine2}}, {{claimDetails?.claim?.pharmacyAddress?.state}}
                {{claimDetails?.claim?.pharmacyAddress?.zipCode}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_PHARMACY_PHONE_NUMBER}}</label>
              <p>{{claimDetails?.claim?.pharmacyPhoneNumber? claimDetails?.claim?.pharmacyPhoneNumber: '-'}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_PHARMACY_STORE_NUMBER}}</label>
              <p>{{claimDetails?.claim?.pharmacyStoreNumber? claimDetails?.claim?.pharmacyStoreNumber: '-' }}</p>
            </div>
          </div>
        </div>

        <div class="custom-block-width">
          <h5 class="text-tertiary title-10 text-w-500">{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_DRUG_INFO}}
          </h5>

          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_MAIL_ORDER_DETAILS_DRUG_NAME}}</label>
              <p>{{claimDetails?.drug?.drugName}} </p>
            </div>
          </div>
          <!-- <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_MEDICATION}}</label>
              <p>Medication</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_BRAND}}/{{multilingualService.langMap?.LABEL_DRUG_PRICING_LEGEND_GENERIC}}</label>
              <p>Monodox</p>
            </div>
          </div> -->
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_SPECIALTY_INDICATOR}}</label>
              <p>{{claimDetails?.drug?.specialty ? 'Yes' : 'No'}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_ROUTE_ADMIN}}</label>
              <p>{{claimDetails?.drug?.routeOfAdmin}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_FORMULARY_TIER}}</label>
              <p>{{claimDetails?.drug?.formularyTier}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_MAINTENANCE}}</label>
              <p>{{claimDetails?.drug?.maintenance ? 'Yes' : 'No'}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_NDC}}</label>
              <p>{{claimDetails?.drug?.ndc}}</p>
            </div>
          </div>
          <h5 class="text-tertiary title-10 text-w-500">
            {{multilingualService.langMap?.LABEL_CLAIM_DETAILS_STATUS_INFORMATION}}</h5>


          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_PRESCRIPTION_DETAILS_STATUS}}</label>
              <p>{{claimDetails?.status?.status}}</p>
            </div>
          </div>
        </div>
        <div class="custom-block-width">


          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_NON_PRIMARY}}</label>
              <p>{{claimDetails?.status?.processedAsNonPrimary? 'Yes':'No'}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIM_DETAILS_ADDITIONAL_MESSAGE}}</label>
              <p>
                {{
                  claimDetails?.status?.aditionalMessage
                    ? claimDetails?.status?.aditionalMessage
                    : claimDetails?.status?.additionalMessage
                    ? claimDetails?.status?.additionalMessage
                    : "N/A"
                }}
              </p>
            </div>
          </div>
          <h5 class="text-tertiary title-10 text-w-500">
            {{multilingualService.langMap?.LABEL_CLAIM_DETAILS_PRICING_INFORMATION}}</h5>

          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIMS_TOTAL_MEMBER_PAY}}</label>
              <p>${{claimDetails?.pricingInformation?.totalMemberPay | number : '1.2-2'}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_CLAIMS_PLAN_AMOUNT}}</label>
              <p>${{claimDetails?.pricingInformation?.planAmount | number : '1.2-2'}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_HOME_COPAY}}</label>
              <p>${{claimDetails?.pricingInformation?.copay | number : '1.2-2'}}</p>
            </div>
          </div>
          <div class="information-block">
            <div class="form-group">
              <label>{{multilingualService.langMap?.LABEL_HOME_PATIENT_PAY}}</label>
              <p>${{claim.patientPay | number : '1.2-2'}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</ng-container>

<div
  aria-busy="true"
  role="status"
  class="center loader-circle"
  *ngIf="isLoading"
>
  <img src="assets/images/loader.gif" alt="loader" width="60px" />
</div>

<div *ngIf="error && !isLoading" class="error-mesg mb-2 empty-box-height">
  <!-- Something went wrong -->
  <div>
    <img
      src="assets/images/wrong.svg"
      alt="Something went wrong"
      width="100px"
    />
    <p role="alert" class="title-10 text-w-700">{{ errMsg }}</p>
  </div>
</div>
